// extracted by mini-css-extract-plugin
export var childrenContainer = "_5j-0";
export var virtualScrollArea = "_5j-1";